import * as z from "zod";
import { dropConnectorUsage, usageRef } from "../connectorUsages";
import { zql } from "../generatedDrizzleSchema";
import { BUILTIN_ROLES, type BuiltinRoleId } from "../rbac/roles";
import { mutator } from "./mutator";

export const deleteSkillSchema = z.object({
  skillId: z.string(),
});

export const deleteSkill = mutator({
  schema: deleteSkillSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, args: { skill } }) => {
    const [installation] = await tx.run(
      zql.skillGitInstallations
        .where("skillId", skill.id)
        .related("source", (source) => source.related("installations"))
    );
    const grants = await tx.run(
      zql.roleGrants.where("scopeId", skill.id).related("customRole")
    );
    for (const g of grants) {
      const scopeKind = g.builtinRoleId
        ? BUILTIN_ROLES[g.builtinRoleId as BuiltinRoleId]?.scopeKind
        : g.customRole?.scopeKind;
      if (scopeKind !== "skill") continue;
      await tx.mutate.roleGrants.delete({ id: g.id });
    }
    await tx.mutate.skills.delete({ id: skill.id });
    if (
      installation?.source &&
      installation.source.installations.length === 1
    ) {
      if (installation.source.connectedAppId) {
        await dropConnectorUsage(
          tx,
          installation.source.connectedAppId,
          usageRef.skillGitSource(installation.source.id)
        );
      }
      await tx.mutate.skillGitSources.delete({
        id: installation.source.id,
      });
    }
  },
});
